import React from 'react'

function GeneralSettings() {
  return (
    <div>GeneralSettings</div>
  )
}

export default GeneralSettings